{
  "emailSlugLabel": "Slug de correo",
  "tabs": {
    "authorizedAccounts": "Cuentas autorizadas",
    "fbos": "FBOs",
    "users": "Usuarios",
    "faaMapping": "Mapeo FAA",
    "announcements": "Anuncios",
    "activity": "Actividad",
    "movableObstacles": "Obstáculos móviles",
    "towingEquipment": "Equipo de remolque",
    "aircraft": "Aeronave",
    "labeling": "Etiquetado",
    "convertSvgs": "Convertir SVGs",
    "systemStatus": "Estado del sistema",
    "quarantine": "Cuarentena",
    "activation": "Activación"
  },
  "uberAdmin": {
    "renderJobHistory": {
      "title": "Historial de renderizado",
      "description": "Trabajos recientes de Render (update-aircraft, movable obstacles, towing equipment). Se actualiza automáticamente cada 20 segundos.",
      "tooltips": {
        "forceRun": "Forzar ejecución restablece el checksum y ejecuta el trabajo aunque los datos no hayan cambiado. Útil para pruebas o para asegurar que todas las bases de datos estén sincronizadas.",
        "refreshing": "Actualizando lista de trabajos..."
      },
      "buttons": {
        "forceRun": "Forzar",
        "running": "Ejecutando..."
      },
      "columns": {
        "jobType": "Tipo tarea",
        "status": "Estado",
        "created": "Creado",
        "duration": "Duración",
        "dashboard": "Panel"
      },
      "jobTypes": {
        "updateAircraft": "Actualizar aeronave",
        "updateMovableObstacles": "Actualizar obstáculos móviles",
        "updateTowingEquipment": "Actualizar equipo de remolque"
      },
      "links": {
        "view": "Ver"
      }
    },
    "errorBoundary": {
      "title": "Algo salió mal",
      "description": "Ocurrió un error al cargar esta sección. Intenta actualizar la página."
    },
    "aircraftLastUpdated": {
      "columns": {
        "checksum": "Checksum",
        "lastUpdated": "Últ. actualización",
        "tableName": "Nombre de tabla"
      },
      "description": "Descripción",
      "notAvailable": "No disponible",
      "title": "Últ. actualiz. aeronave"
    },
    "workerStatus": {
      "columns": {
        "lastChecked": "Últ. verificación",
        "status": "Estado",
        "worker": "Operario"
      },
      "description": "Descripción",
      "notAvailable": "No disponible",
      "title": "Estado trabajador"
    }
  },
  "components": {
    "aircraftTable": {
      "searchPlaceholder": "Buscar aeronave...",
      "headers": {
        "make": "Crear",
        "model": "Modelo",
        "length": "Longitud",
        "wingspan": "Envergadura",
        "tailHeight": "Altura de cola",
        "status": "Estado"
      },
      "status": {
        "deployed": "Desplegado",
        "labeling": "Etiquetado",
        "locked": "Bloqueado"
      }
    }
  },
  "announcementsAdmin": {
    "dialogTitle": {
      "new": "Nuevo anuncio",
      "edit": "Editar anuncio"
    },
    "labels": {
      "title": "Título",
      "body": "Cuerpo",
      "mediaType": "Tipo de medio",
      "youtubeEmbed": "Código embed de YouTube",
      "uploadImage": "Subir imagen",
      "changeImage": "Cambiar imagen",
      "actionLink": "Enlace de acción (opcional)",
      "linkButtonText": "Texto del botón de enlace (opcional)",
      "expirationDate": "Fecha de vencimiento"
    },
    "helperText": {
      "youtubeEmbed": "Pega el código de inserción del iframe de YouTube",
      "actionLink": "Ingresa una URL para añadir un enlace al anuncio",
      "linkButtonText": "Por defecto: 'Más info'"
    },
    "placeholders": {
      "actionLink": "https://example.com",
      "linkButtonText": "Más información"
    },
    "preview": {
      "expires": "Vence: "
    },
    "errors": {
      "titleRequired": "El título es obligatorio",
      "bodyRequired": "El cuerpo es obligatorio",
      "expirationRequired": "La fecha de vencimiento es obligatoria",
      "invalidYouTube": "Ingresa un código de inserción de iframe de YouTube válido",
      "videoUrlRequired": "La URL del video es obligatoria cuando se selecciona video",
      "imageRequired": "Sube una imagen",
      "invalidUrl": "Ingresa una URL válida (ej., https://example.com)",
      "saveFailed": "No se pudo guardar el anuncio. Intenta de nuevo."
    },
    "confirmDelete": "¿Seguro que deseas eliminar este anuncio?",
    "buttons": {
      "create": "Crear",
      "update": "Actualzr",
      "uploading": "Subiendo...",
      "cancel": "Cancelar",
      "addAnnouncement": "Añadir anuncio",
      "preview": "Previsual.",
      "edit": "Editar",
      "delete": "Eliminar",
      "close": "Cerrar"
    },
    "columns": {
      "title": "Título",
      "body": "Cuerpo",
      "media": "Medios",
      "link": "Enlace",
      "status": "Estado",
      "expires": "Vence",
      "actions": "Acciones"
    },
    "status": {
      "active": "Activo",
      "expired": "Vencido"
    },
    "mediaTypes": {
      "none": "Ning.",
      "image": "Imagen",
      "video": "Video"
    }
  },
  "quarantineTab": {
    "title": "Inquilinos pendientes (cuarentena)",
    "description": "Aeronaves que no pudieron vincularse con el registro de la FAA o la biblioteca de aeronaves durante la importación de datos. Selecciona una aeronave para mapear en línea, o usa \"Eliminar y reintentar\" para borrar y esperar la próxima sincronización.",
    "successMessage": "No hay operadores pendientes: ¡todas las aeronaves importadas han sido vinculadas correctamente!",
    "buttons": {
      "refresh": "Actualizar",
      "removeAndRetry": "Eliminar y reintentar ({{count}})"
    },
    "tableHeaders": {
      "tailNumber": "Matrícula",
      "fbo": "FBO",
      "typeHint": "Tipo de dato",
      "mapToAircraft": "Asignar a aeronave",
      "register": "Registrarse",
      "source": "Origen",
      "created": "Creado"
    },
    "tooltips": {
      "registerExplainer": "Registrar matrícula en la base de datos de la FAA. Desmarcar para matrículas de cotización o provisionales.",
      "willAddToFaa": "Se añadirá a base de datos FAA",
      "quotePlaceholder": "Cotización/ejemplo - no afectará la base de datos FAA",
      "placeholderWarning": "Parece ser una matrícula provisional - no se añadirá a la base de datos de la FAA a menos que se marque"
    },
    "table": {
      "noPendingTenants": "Sin inquilinos pendientes",
      "mapping": "Mapeando...",
      "selectAircraft": "Seleccionar aeronave"
    },
    "defaults": {
      "unknownFbo": "FBO desconocido",
      "unknownOperator": "Desconocido",
      "unknownTypeHint": "Desconoc."
    },
    "dialog": {
      "title": "Eliminar inquilinos pendientes y reintentar",
      "description": "Eliminar {{count}} inquilino(s) pendiente(s) de la cola de cuarentena.",
      "autoRetryTitle": "Reintento automático:",
      "autoRetryBody": "La próxima sincronización de datos programada (se ejecuta cada 5 minutos) intentará crear estos inquilinos automáticamente. Si corregiste el mapeo FAA (agregaste la aeronave a la biblioteca o actualizaste la tabla faa_to_airplx), el inquilino se creará correctamente.",
      "retryNote": "Si el mapeo sigue faltando, el tenant será puesto en cuarentena nuevamente. Puedes corregir el mapeo e intentar de nuevo.",
      "cancelButton": "Cancelar",
      "confirmButton": "Eliminar y reintentar en próx. sync",
      "removing": "Eliminando..."
    },
    "snackbar": {
      "removed": "Eliminado {{count}} inquilino(s) pendiente(s)",
      "mapFailed": "Error al asignar aeronave"
    },
    "pendingCount": "Pendientes",
    "selectionCount": "Seleccionados"
  },
  "aircraftAdmin": {
    "title": "Base de aeronaves",
    "loading": "Cargando datos de aeronave...",
    "status": {
      "locked": "Bloqueado",
      "deployed": "Desplegado",
      "labeling": "Etiquetado"
    },
    "exportHeaders": {
      "make": "Crear",
      "model": "Modelo",
      "length": "Longitud",
      "wingspan": "Envergadura",
      "tailHeight": "Altura de cola",
      "status": "Estado",
      "id": "ID"
    },
    "aircraftDeployed": "Aeronaves desplegadas: <strong>{{count}}</strong>",
    "exportButton": "Exportar lista de aeronaves"
  },
  "aircraftPreview": {
    "selectPrompt": "Selecciona una aeronave para previsualizar",
    "noImage": "Sin imagen disponible",
    "editButton": "Editar",
    "fields": {
      "id": "ID:",
      "length": "Longitud:",
      "wingspan": "Envergadura:",
      "tailHeight": "Altura de cola:",
      "linkedTo": "Vinculado a:"
    }
  },
  "flightBridgeStatus": {
    "title": "Integraciones de FlightBridge",
    "description": "FlightBridge sincroniza programaciones de vuelos y reservas de concierge desde sistemas externos de operaciones de vuelo. Cada integración de FBO se sincroniza de forma incremental mediante webhooks y actualizaciones programadas.",
    "columns": {
      "fbo": "FBO",
      "companyId": "ID de empresa",
      "status": "Estado",
      "lastSync": "Últ. sinc.",
      "error": "Error"
    },
    "never": "Nunca"
  },
  "recentActivity": {
    "noActivity": "Sin actividad reciente",
    "columns": {
      "user": "Usuar",
      "fbo": "FBO",
      "timestamp": "Fecha y hora"
    }
  },
  "weeklyActivityTable": {
    "title": "Actividad semanal",
    "noData": "No hay datos de actividad disponibles para el período seleccionado.",
    "exportButton": "Exportar TSV",
    "showTestFBOs": "Mostrar FBOs prueba",
    "columns": {
      "fbo": "FBO"
    },
    "metrics": {
      "totalCustomers": "Total de clientes",
      "weeklyActive": "Activos semanales",
      "monthlyActive": "Activos mensuales"
    },
    "footer": {
      "totalFBOs": "Total de FBOs:"
    }
  },
  "superUserAdmin": {
    "loading": "Cargando...",
    "columns": {
      "userId": "ID usuario",
      "name": "Nombre",
      "email": "Correo",
      "fbo": "FBO",
      "action": "Acción",
      "permissions": "Permisos"
    },
    "placeholders": {
      "none": "---",
      "searchUser": "Buscar usuario",
      "searchFBO": "Buscar FBO"
    },
    "buttons": {
      "edit": "Editar",
      "close": "Cerrar",
      "save": "Guardar",
      "saving": "Guardando..."
    },
    "roles": {
      "none": "Ning."
    },
    "moreChip": "+ {{count}} más",
    "dialog": {
      "title": "Editar user"
    }
  },
  "buttonRemoveFBO": {
    "button": "Eliminar FBO",
    "dialog": {
      "title": "Confirmar eliminación de FBO",
      "message": "¿Está seguro de que desea eliminar este FBO? Esta acción no se puede deshacer.",
      "cancelButton": "Cancelar",
      "confirmButton": "Confirmar"
    }
  },
  "towingEquipmentAdmin": {
    "loading": "Cargando equipo de remolque...",
    "buttons": {
      "addEquipment": "Añadir equipo",
      "exportList": "Exportar lista de equipos",
      "deploy": "Desplegar"
    },
    "tooltips": {
      "deployOnlyProduction": "Desplegar solo está disponible en producción (app.airplx.com)"
    },
    "confirmations": {
      "deleteMessage": "¿Seguro que deseas eliminar \"{{name}}\"?",
      "deployTitle": "Confirmar despliegue",
      "deployMessage": "¿Confirmas que deseas aplicar las actualizaciones de equipos de remolque?",
      "deployOkButton": "¡Vamos!"
    },
    "errors": {
      "deleteFailed": "No se pudo eliminar el equipo: {{error}}",
      "nameRequired": "Proporcione un nombre para el equipo.",
      "invalidDimensions": "Ingrese valores válidos para todos los campos de dimensiones. Las dimensiones deben ser números positivos de hasta 1000 pies.",
      "createFailed": "No se pudo crear el equipo. Intenta de nuevo.",
      "saveFailed": "No se pudo guardar el equipo: {{error}}",
      "widthInvalid": "El ancho debe ser un número positivo de hasta 1000 pies.",
      "lengthInvalid": "La longitud debe ser un número positivo de hasta 1000 pies.",
      "heightInvalid": "La altura debe ser un número positivo de hasta 1000 pies."
    },
    "exportHeaders": {
      "name": "Nombre",
      "width": "Ancho",
      "length": "Longitud",
      "height": "Altura",
      "towBarLength": "Largo barra remolque",
      "id": "ID"
    }
  },
  "movableObstacleAdmin": {
    "loading": "Cargando obstáculos...",
    "buttons": {
      "addObstacle": "Añadir obstáculo",
      "exportList": "Exportar lista de obstáculos",
      "deploy": "Desplegar"
    },
    "tooltips": {
      "deployOnlyProduction": "Desplegar solo está disponible en producción (app.airplx.com)"
    },
    "confirmations": {
      "deleteMessage": "¿Seguro que deseas eliminar \"{{name}}\"?",
      "deployTitle": "Confirmar despliegue",
      "deployMessage": "¿Seguro que deseas desplegar?",
      "deployOkButton": "¡Vamos!"
    },
    "errors": {
      "deleteFailed": "No se pudo eliminar el obstáculo: {{error}}",
      "invalidDimensions": "Por favor, ingrese valores válidos en todos los campos. Las dimensiones deben ser números positivos de hasta 1000 pies.",
      "createFailed": "No se pudo crear el obstáculo. Inténtelo de nuevo.",
      "saveFailed": "No se pudo guardar el obstáculo: {{error}}",
      "widthInvalid": "El ancho debe ser un número positivo de hasta 1000 pies.",
      "lengthInvalid": "La longitud debe ser un número positivo de hasta 1000 pies.",
      "heightInvalid": "La altura debe ser un número positivo de hasta 1000 pies."
    },
    "exportHeaders": {
      "name": "Nombre",
      "width": "Ancho",
      "length": "Longitud",
      "height": "Altura",
      "id": "ID"
    }
  },
  "aircraftMappingTab": {
    "coverage": "Cobertura: {{percentage}}% ({{mappedTails}} / {{totalTails}})",
    "searchPlaceholder": "Buscar por fabricante o modelo FAA",
    "filters": {
      "manufacturer": "Fabricante",
      "country": "País",
      "allCountries": "Todo",
      "unmatched": "Sin coincid.",
      "withSuggestions": "Con sugerencias"
    },
    "tableHeaders": {
      "frequency": "Frecuencia",
      "faaManufacturer": "Fabricante FAA",
      "faaModel": "Modelo FAA",
      "airplxAircraft": "AirPlx Aircraft"
    },
    "tooltips": {
      "frequencyAllCountries": "Número total de matrículas registradas para este tipo de aeronave",
      "frequencyWithCountry": "Formato: \"cantidadPaís (cantidadTotal)\" - Mostrando registros de {{country}} con el total mundial entre paréntesis. Ordenado por cantidad de {{country}}.",
      "blacklist": "Bloquear este tipo FAA (drones, globos, etc.)"
    },
    "snackbar": {
      "blacklisted": "Bloqueado \"{{manufacturer}} {{model}}\"",
      "blacklistFailed": "No se pudo bloquear. Inténtalo de nuevo.",
      "bulkApplySuccess": "Aplicadas {{appliedCount}} asignaciones ({{skippedCount}} omitidas)",
      "bulkApplyFailed": "Aplicación masiva fallida: {{message}}",
      "reApplySuccess": "Patrón \"{{query}}\" reaplicado: {{appliedCount}} asignaciones ({{skippedCount}} omitidas)",
      "reApplyFailed": "Falló al reaplicar: {{message}}",
      "patternDeleted": "Patrón eliminado",
      "patternDeleteFailed": "Eliminación fallida: {{message}}"
    }
  },
  "activation": {
    "overview": {
      "title": "Resumen de activación de usuarios",
      "description": "Monitorea y gestiona el progreso de activación de usuarios en todos los FBOs",
      "filterLabel": "Filtrar",
      "noData": "Sin registros de activación",
      "viewDetails": "Ver detalles",
      "columns": {
        "user": "Usuar",
        "fboName": "FBO",
        "state": "Estado",
        "autostackRuns": "Ejecuciones AutoStack",
        "checklist": "Checklist",
        "timeline": "Línea de tiempo",
        "mode": "Mostrar checklist",
        "actions": "Acciones"
      },
      "states": {
        "pre": "Preactivación",
        "shallow": "Poco fondo",
        "deep": "Hondo"
      },
      "filters": {
        "all": "Todos",
        "active": "Solo activos",
        "stalled": "Detenido",
        "deep": "Profundo activado"
      },
      "fboFilter": "FBO",
      "allFbos": "Todos FBOs",
      "searchPlaceholder": "Buscar por nombre o correo"
    },
    "detail": {
      "title": "Detalles de activación",
      "userInfo": "Información del usuario",
      "checklistProgress": "Progreso del checklist",
      "adminControls": "Admin. y controles",
      "auditLog": "Historial de cambios",
      "notes": "Notas internas",
      "reason": "Motivo del cambio",
      "reasonHelp": "Nota opcional para registro de auditoría",
      "notCompleted": "No completado",
      "markComplete": "Marcar completado",
      "uncheckStep": "Restablecer paso (desmarcar)",
      "controls": {
        "startDate": {
          "label": "Activación iniciada",
          "help": "Ajustar para correcciones de tiempo de prueba",
          "update": "Actualizar"
        },
        "windowDays": {
          "label": "Ventana de activación (días)",
          "help": "Extender o acortar el período de activación"
        },
        "threshold": {
          "label": "Umbral de activación profunda",
          "help": "Cuántas ejecuciones de AutoStack = activación profunda"
        },
        "variant": {
          "label": "Estilo de checklist",
          "help": "Qué variante de interfaz mostrar",
          "options": {
            "sidebar": "Panel lateral",
            "floating": "Tarjeta flotante",
            "banner": "Banner superior"
          }
        },
        "forceDeep": {
          "label": "Forzar activación profunda",
          "help": "Marcar manualmente como activación profunda (poco común)"
        }
      }
    }
  }
}
